import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import * as React from "react";
import { css } from "styled-components";

export interface AddToCartContainerStyles {
    container?: GridContainerProps;
}

export const AddToCartContainerStyles: AddToCartContainerStyles = {
    container: {
        css: css`
            max-width: 350px !important;
        `,
    },
};

const styles = AddToCartContainerStyles;

type Props = WidgetProps;

const AddToCartContainer: React.FC<Props> = ({ id }) => {
    return (
        <GridContainer {...styles.container}>
            <GridItem width={4} align="bottom">
                <Zone contentId={id} zoneName="Qty" />
            </GridItem>
            <GridItem width={8} align="bottom">
                <Zone contentId={id} zoneName="CartButton" />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: AddToCartContainer,
    definition: {
        displayName: "Add To Cart Container",
        group: "Product Details",
        fieldDefinitions: [],
    },
};

export default widgetModule;
